import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssetService from "../../Controller/AssetController"
import { handleChange, handleSubmit } from "../../Controller/UpdateAssetNotesController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import { quillModules, quillFormats, addToolbarTitles } from "../../../Common/quillConfig";
import SunTextEditor from "../../../Common/SunTextEditor";
function AssetNotes(AssetID) {
    AssetID = localStorage.getItem('AssetID');
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [formData, setFormData] = useState({ vc_Notes: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const fetchAssetNotes = async () => {
        try {
            const data = await AssetService.GetAssetByID(redirectCallback, AssetID);
            setFormData({ vc_Notes: data[0].vc_Notes });
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    useEffect(() => {
        setFormData({});
        if (AssetID > 0) {
            fetchAssetNotes();
        }
    }, [AssetID]); // Trigger useEffect when AssetID changes

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Notes: content
        });
    };

    const handleFormSubmit = async (event) => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };

        formData.PK_Assets_ID = AssetID;
        const message = await handleSubmit(event, formData, setFormData, setErrors);
        if (message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
        fetchAssetNotes();
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3">
                    <div className="col-xl-12" style={{ "textAlign": "right" }}>
                       
                    </div>
                </div>
                <div className="row mb-3" style={{ "marginTop": "10px" }}>

                    <div className="col-sm-12">
                        <SunTextEditor
                            value={formData.vc_Notes}
                            onChange={(content) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    vc_Notes: content,
                                }))
                            }
                        />
                        {errors.vc_Notes && <div style={{ color: 'red' }}>{errors.vc_Notes}</div>}
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-12">
                        <div className="row" style={{ "marginLeft": "0px", "float": "right" }}>
                            <div className="col-sm-12">
                                <button type="submit" className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                    <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save

                                    
                                </button>

                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    );
}
export default AssetNotes;